import { useCoursePlannerStore } from '~~/layers/courseplanner/app/stores/coursePlannerStore';
import { useCourseRecommendationsStore } from '~~/layers/courserecs/app/stores/courseRecommendationsStore';
import { useJobCoachStore } from '~~/layers/jobcoach/app/stores/jobCoachStore';
import { useLeydenMobileStore } from '~~/layers/mobile/app/stores/leydenMobileStore';
import { useMtssStore } from '~~/layers/mtss/app/stores/mtssStore';
import { useScanningStore } from '~~/layers/scanning/app/stores/scanningStore';
import { useSchoologyStore } from '~~/layers/schoology/app/stores/schoologyStore';
import { useSubstituteStore } from '~~/layers/sub/app/stores/substituteStore';
import { useSystemsManagerStore } from '~~/layers/systemsmanager/app/stores/systemsManagerStore';
import { useTechLoanerStore } from '~~/layers/techloaner/app/stores/techLoanerStore';

const loadOnInitialRoute = (to, from, routePrefix) => {
  return to.path.startsWith(routePrefix) && (!from.path.startsWith(routePrefix) || from.name === undefined)
}

export default defineNuxtRouteMiddleware(async (to, from) => {

  // We only care about auth on the client (SPA)
  if (!true || to.meta.auth === false) return;

  if (loadOnInitialRoute(to, from, '/courseplanner')) {
    const courseplanner = useCoursePlannerStore();
    await courseplanner.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/courserecs')) {
    const courserecs = useCourseRecommendationsStore();
    await courserecs.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/jobcoach')) {
    const jc = useJobCoachStore();
    await jc.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/mobile')) {
    const mobile = useLeydenMobileStore();
    await mobile.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/mtss')) {
    const mtss = useMtssStore();
    await mtss.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/scanning')) {
    const scan = useScanningStore();
    await scan.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/schoology')) {
    const slgy = useSchoologyStore();
    await slgy.loadConfig();
    slgy.startListening();
  }

  if (loadOnInitialRoute(to, from, '/sub')) {
    const sub = useSubstituteStore();
    await sub.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/systemsmanager')) {
    const systemsmanager = useSystemsManagerStore();
    await systemsmanager.loadConfig();
  }

  if (loadOnInitialRoute(to, from, '/techloaner')) {
    const techloaner = useTechLoanerStore();
    await techloaner.loadConfig();
  }

});
